module.exports = __webpack_public_path__ + "static/media/adidas-logo.087108f7.svg";